<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2p"><a id="page_7">PART ONE</a></h2><a id="page_7">
<hr class="hrpt"/>
<h2 class="h2ps">The <span class="txit">New</span> New Realities of America at Work</h2>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?003d4536